module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_swedish-club.599a4ab8.pdf";